export enum PersistedStateKeyEnum {
  DirectMailSearchFormState = 'direct_mail_search_form_state',
  DirectMailSearchType = 'direct_mail_search_type',
  ManualSearchFormState = 'manual_search_form_state',
  SearchType = 'search_type',
  SearchMoxyCustomerNumberFormState = 'search_moxy_customer_number_form_state',
  DealLogFormState = 'deal_log_form_state',
  DarkMode = 'dark_mode',
}
